import { useState, useEffect } from "react";
import { Star } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function StarRating({ rating }) {
  return (
    <div className="flex gap-0.5">
      {[...Array(5)].map((_, i) => (
        <Star
          key={i}
          size={16}
          className={i < rating ? "text-[#F59E0B] fill-[#F59E0B]" : "text-stone-300"}
        />
      ))}
    </div>
  );
}

const fallbackTestimonials = [
  {
    id: "1", name: "Aminata K.", city: "Abidjan", rating: 5,
    text: "Depuis que je prends le Super 7, je me sens beaucoup plus en forme. Je le recommande vivement à toutes les mamans !"
  },
  {
    id: "2", name: "Kouadio J.", city: "Yamoussoukro", rating: 5,
    text: "Le Men 7 a changé mon quotidien. Plus d'énergie au travail et une meilleure concentration. Merci Santé KACINOÉ !"
  },
  {
    id: "3", name: "Fatou D.", city: "Bouaké", rating: 4,
    text: "La Crème 7 est incroyable pour ma peau. En deux semaines, j'ai vu une vraie différence. Produit de qualité !"
  },
];

export default function Testimonials() {
  const [testimonials, setTestimonials] = useState(fallbackTestimonials);

  useEffect(() => {
    async function fetchTestimonials() {
      try {
        const res = await axios.get(`${API}/testimonials`);
        if (res.data.length > 0) {
          setTestimonials(res.data);
        }
      } catch (err) {
        console.error("Error fetching testimonials:", err);
      }
    }
    fetchTestimonials();
  }, []);

  return (
    <section id="temoignages" data-testid="testimonials-section" className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14 fade-up">
          <h2
            className="text-3xl md:text-4xl font-semibold text-stone-900 mb-4"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Ce que disent nos clients
          </h2>
          <p className="text-base md:text-lg text-stone-600 max-w-xl mx-auto">
            Des milliers de clients satisfaits à travers la Côte d'Ivoire.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={testimonial.id}
              data-testid={`testimonial-card-${index}`}
              className={`fade-up fade-up-delay-${index + 1} bg-[#F5F0E8]/50 rounded-2xl p-8 relative`}
            >
              {/* Quote mark */}
              <div className="absolute top-4 right-6 text-[#6C3FC5]/10 text-7xl font-serif leading-none select-none">
                "
              </div>

              <StarRating rating={testimonial.rating} />

              <p className="text-stone-700 mt-4 mb-6 leading-relaxed text-sm relative z-10">
                "{testimonial.text}"
              </p>

              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-[#6C3FC5] flex items-center justify-center text-white font-medium text-sm">
                  {testimonial.name.charAt(0)}
                </div>
                <div>
                  <p className="font-medium text-stone-900 text-sm">{testimonial.name}</p>
                  <p className="text-stone-500 text-xs">{testimonial.city}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
